import React from 'react'
import "./StudentPage.css"
import Nav from './Nav'
import Banner from './Banner'

const StudentPage = () => {
  return (
    <div className='studentpage'>
        <Banner/>
        <Nav/> 
    </div>
  )
}

export default StudentPage
